import { LOG_OUT } from '../../actionTypes';

export default () => async (dispatch) => {
  dispatch({
    type: LOG_OUT,
  });
};
